import React from "react";
import classnames from "classnames";
import * as Collapsible from "@radix-ui/react-collapsible";
import { FiChevronDown } from "react-icons/fi";
import Button from "components/Button";
import "./SimpleAccordion.scss";

interface SimpleAccordionProps {
  title?: string;
  subtext?: string;
  // Former prop-types declared `body` as a function, but it is rendered as
  // content (<p>{body}</p>); typed as a node to match actual usage.
  body?: React.ReactNode;
  onClick?: React.MouseEventHandler<HTMLButtonElement>;
  actionText?: string;
  defaultStyle?: boolean;
}

const SimpleAccordion = ({
  title,
  onClick,
  actionText,
  body,
}: SimpleAccordionProps) => {
  return (
    <div className="simple-accordion">
      <Collapsible.Root className="Collapsible">
        <Collapsible.Trigger asChild>
          <div className={classnames("accordion-item", "Collapsible__trigger")}>
            <div className="item">
              <div className="item-description">
                <p className="title">{title}</p>
              </div>
            </div>

            <div className={classnames("trigger")}>
              <FiChevronDown color="white" stroke={"#858c9c"} size={16} />
            </div>
          </div>
        </Collapsible.Trigger>
        <Collapsible.Content>
          <div className="accordion-body">
            <p className="body">{body}</p>

            {onClick && (
              <div className="accordion-action-btn">
                <Button
                  size="sm"
                  name="action"
                  withArrow={true}
                  onClick={onClick}
                >
                  {actionText}
                </Button>
              </div>
            )}
          </div>
        </Collapsible.Content>
      </Collapsible.Root>
    </div>
  );
};

export default SimpleAccordion;
